/**
 * Which refusals a client may press through, by code.
 *
 * GENERATED — do not edit. The rule lives beside the codes it is about, in
 * `src/pms-api/pkg/enums/error/main.go`, and this file is written from it by
 * `HTTP_API/ErrorAttributes_test.go`. Change the Go table and run
 * `go test ./HTTP_API`; the test regenerates this file and fails until it is
 * committed.
 *
 * # It is the FALLBACK and not the answer
 *
 * Every refusal the service writes carries its own verdict — `retryable` and
 * `operation_closed` beside `code` and `message` — and `libs/operation.ts` prefers those
 * two over this map every time. What this is for is a body that has neither: an older
 * service behind the edge during a deploy, a cached answer, a refusal relayed by
 * something that only kept the code. Without it a portal mid-deploy would treat every
 * closed operation as an open one, which is the fault the whole mechanism exists to
 * stop.
 *
 * # The three states
 *
 * `retryable` — the same body under the same operation id may be sent again and may
 * succeed with nobody changing anything.
 * `terminal` — that operation can achieve nothing more: drop the name and re-read.
 * Neither — a person has to change something, and the name is kept so that the press
 * after the repair is still one act.
 *
 * They are never both true.
 */

export interface IErrorAttributes {
    /** The same request under the same name may be sent again. */
    retryable: boolean
    /** The operation that name stands for is closed: forget it and re-read. */
    terminal:  boolean
}

/** What an unknown code answers: the humble verdict, which keeps a name rather than burning it. */
const NEITHER: IErrorAttributes = { retryable: false, terminal: false }

export const errorAttributes: Readonly<Record<number, IErrorAttributes>> = {
    1: { retryable: true,  terminal: false },
    2: { retryable: false, terminal: true },
    3: { retryable: false, terminal: true },
    4: { retryable: false, terminal: false },
    5: { retryable: false, terminal: true },
    6: { retryable: false, terminal: true },
    7: { retryable: false, terminal: false },
    8: { retryable: false, terminal: true },
    9: { retryable: false, terminal: false },
    10: { retryable: false, terminal: false },
    11: { retryable: true,  terminal: false },
    12: { retryable: false, terminal: true },
    13: { retryable: false, terminal: false },
    14: { retryable: false, terminal: true },
    15: { retryable: false, terminal: true },
    16: { retryable: false, terminal: true },
    17: { retryable: false, terminal: false },
    18: { retryable: false, terminal: false },
    19: { retryable: false, terminal: false },
    20: { retryable: false, terminal: false },
    21: { retryable: false, terminal: false },
    22: { retryable: false, terminal: true },
    23: { retryable: false, terminal: false },
    24: { retryable: false, terminal: false },
    25: { retryable: false, terminal: false },
    26: { retryable: false, terminal: false },
    27: { retryable: false, terminal: false },
    28: { retryable: false, terminal: false },
    29: { retryable: false, terminal: false },
    30: { retryable: false, terminal: false },
    31: { retryable: false, terminal: true },
    32: { retryable: false, terminal: false },
    33: { retryable: false, terminal: true },
    34: { retryable: false, terminal: false },
    35: { retryable: false, terminal: false },
    36: { retryable: false, terminal: true },
    37: { retryable: false, terminal: false },
    38: { retryable: false, terminal: true },
    39: { retryable: false, terminal: false },
    40: { retryable: false, terminal: true },
    41: { retryable: false, terminal: true },
    42: { retryable: false, terminal: false },
    43: { retryable: false, terminal: false },
    44: { retryable: false, terminal: false },
    45: { retryable: true,  terminal: false },
    46: { retryable: false, terminal: true },
    47: { retryable: false, terminal: false },
    48: { retryable: false, terminal: false },
    49: { retryable: false, terminal: false },
    50: { retryable: false, terminal: false },
    51: { retryable: false, terminal: false },
    52: { retryable: false, terminal: false },
    53: { retryable: false, terminal: false },
    54: { retryable: true,  terminal: false },
    55: { retryable: false, terminal: true },
    56: { retryable: false, terminal: true },
    57: { retryable: false, terminal: false },
    58: { retryable: true,  terminal: false },
    59: { retryable: false, terminal: true },
    61: { retryable: false, terminal: true },
    62: { retryable: true,  terminal: false },
    63: { retryable: false, terminal: false },
    64: { retryable: false, terminal: false },
    67: { retryable: false, terminal: false },
    68: { retryable: false, terminal: false },
    69: { retryable: false, terminal: true },
    70: { retryable: false, terminal: false },
    71: { retryable: false, terminal: false },
    75: { retryable: false, terminal: false },
    80: { retryable: false, terminal: false },
    90: { retryable: false, terminal: false },
    95: { retryable: false, terminal: false },
    96: { retryable: true,  terminal: false },
    97: { retryable: false, terminal: false },
    98: { retryable: false, terminal: true },
    99: { retryable: false, terminal: false },
    100: { retryable: false, terminal: false },
    101: { retryable: false, terminal: false },
    102: { retryable: false, terminal: false },
    103: { retryable: false, terminal: false },
    104: { retryable: false, terminal: true },
    105: { retryable: false, terminal: false },
    106: { retryable: false, terminal: false },
    107: { retryable: false, terminal: false },
    108: { retryable: false, terminal: false },
    109: { retryable: false, terminal: false },
    110: { retryable: false, terminal: false },
    111: { retryable: false, terminal: false },
    112: { retryable: false, terminal: false },
    113: { retryable: false, terminal: true },
    114: { retryable: true,  terminal: false },
    115: { retryable: false, terminal: false },
    116: { retryable: false, terminal: false },
    117: { retryable: false, terminal: false },
    118: { retryable: false, terminal: false },
    119: { retryable: false, terminal: false },
    120: { retryable: false, terminal: false },
    121: { retryable: false, terminal: false },
    122: { retryable: false, terminal: false },
    123: { retryable: false, terminal: false },
    124: { retryable: false, terminal: false },
    125: { retryable: false, terminal: false },
    126: { retryable: false, terminal: false },
    127: { retryable: false, terminal: false },
    128: { retryable: false, terminal: false },
    129: { retryable: false, terminal: false },
    130: { retryable: false, terminal: false },
    131: { retryable: true,  terminal: false },
    132: { retryable: false, terminal: true },
    133: { retryable: true,  terminal: false },
    134: { retryable: false, terminal: true },
    135: { retryable: false, terminal: true },
    136: { retryable: true,  terminal: false },
    137: { retryable: false, terminal: false },
    138: { retryable: true,  terminal: false },
    139: { retryable: false, terminal: false },
    140: { retryable: false, terminal: false },
    141: { retryable: false, terminal: false },
    142: { retryable: false, terminal: false },
    143: { retryable: false, terminal: false },
}

/** One code's verdict. Unknown codes are neither, which is what an old client's silence means. */
export const errorAttributesOf = (code: number): IErrorAttributes => errorAttributes[code] ?? NEITHER
